import { scale, verticalScale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  listStyle: { marginHorizontal: scale(16), marginVertical: verticalScale(14) },
  modalContent: {
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '80%',
    minHeight: '50%',
  },
  modalListContainer: {
    flex: 1,
  },
  selectedNominalStyles: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    marginRight: scale(16),
    marginTop: verticalScale(8),
  },
});
export default styles;
